import { getApiBase, authHeaders } from 'utils/api/api';
import { createSseParser } from './sse';

// FIN-1314: one turn of the chat. The backend streams server-sent events while the loop
// model → tool → model runs; every event goes to onEvent as it arrives. Resolves when the
// stream ends, rejects on an HTTP refusal (401, 403, 503) or an aborted request.
export const streamChat = async ({ text, page, transcript, conversation_id: conversationId }, onEvent, signal) => {
  const response = await fetch(`${getApiBase()}/assistant/chat`, {
    method: 'POST',
    headers: { ...authHeaders(), Accept: 'text/event-stream' },
    body: JSON.stringify({ text, page, transcript, conversation_id: conversationId }),
    signal,
  });

  if (!response.ok) throw new Error(await refusal(response));

  const parser = createSseParser(onEvent);
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  for (;;) {
    // eslint-disable-next-line no-await-in-loop
    const { value, done } = await reader.read();
    if (done) break;
    parser.push(decoder.decode(value, { stream: true }));
  }
  parser.end();
};

const refusal = async (response) => {
  try {
    const body = await response.json();
    if (body && body.error) return body.error;
  } catch (e) {
    // no readable body — the status is the message
  }
  return `HTTP ${response.status}`;
};

// The chats page: the person's conversations, one in full, a new name, hiding one
const json = async (path, options = {}) => {
  const response = await fetch(`${getApiBase()}${path}`, { headers: authHeaders(), ...options });
  if (!response.ok) throw new Error(await refusal(response));
  return response.status === 204 ? null : response.json();
};

export const listConversations = (query) => (
  json(`/assistant/conversations${query ? `?q=${encodeURIComponent(query)}` : ''}`).then((body) => body.data)
);

export const getConversation = (id) => json(`/assistant/conversations/${encodeURIComponent(id)}`);

export const renameConversation = (id, title) => (
  json(`/assistant/conversations/${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify({ title }) })
    .then((body) => body.conversation)
);

export const hideConversation = (id) => json(`/assistant/conversations/${encodeURIComponent(id)}`, { method: 'DELETE' });
